import { z } from 'zod';
import { SUPPORTED_LOCALES } from '../constants/index.js';

export const ProfileSchema = z.object({
  first_name: z.string().trim().min(1, 'profile.firstName.required').max(80),
  last_name: z.string().trim().min(1, 'profile.lastName.required').max(80),
  dob: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'profile.dob.invalid')
    .refine((v) => {
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return false;
      const age = (Date.now() - d.getTime()) / (365.25 * 24 * 60 * 60 * 1000);
      return age >= 18 && age <= 120;
    }, 'profile.dob.ageRange')
    .nullable()
    .optional(),
  address: z.string().trim().min(1).max(200).nullable().optional(),
  country: z.string().trim().length(2, 'profile.country.iso2').toUpperCase().nullable().optional(),
  language: z.enum(SUPPORTED_LOCALES).default('fr'),
});
export type ProfileInput = z.infer<typeof ProfileSchema>;
